import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { useStore } from '../../../store';
import { IPlanPickerResponse } from '../types';
import { IServerErrorResponse } from '../../../types';

interface IProps {
  onError: (errorMessage: string) => void
}
export const useGetPlansData = ({ onError }: IProps) => {
  const { customerId } = useStore(state => state.user);
  return useQuery(
    'GetPlansData',
    async () => {
      const res = await httpService.get(`${BASE_URL}/api/v2/user/${customerId}/account/plans`);
      return res.data as IPlanPickerResponse;
    },
    {
      cacheTime: 5,
      enabled: true,
      retry: 2,
      retryDelay: 1,
      refetchOnWindowFocus: false,
      onError: (error: IServerErrorResponse) => {
        onError(error.response.data?.errors?.[0].localizedMessage || 'Something went wrong');
      },
    },
  );
};
